export default (state = {}) => state.locale || {};
